/** Copyright (c) 2020 T.Rowe Price. All rights reserved. */
import { isBoolean } from 'lodash';

import {
  DELAY_LINK_ACCOUNT,
  RECEIVED_EXTERNAL_INVESTMENT_STATUS,
  RECEIVED_EXTERNAL_INVESTMENT_CONSENT,
  RECEIVED_SET_EXTERNAL_INVESTMENT_CONSENT,
  UPDATE_EXTERNAL_INVESTMENT_STATUS,
  SET_EXTERNAL_INVESTMENT_CONSENT,
  SHOW_CONSENT_MODAL,
  SHOW_LINK_MODAL
} from './ExternalInvestmentConsentActions';

const initialState = {
  status: null,
  consent: null,
  showConsentModal: false,
  showLinkModal: false,
  delayLinkAccount: false
};

export const externalInvestmentConsentReducer = (
  state = initialState,
  action
) => {
  if (action.type === RECEIVED_EXTERNAL_INVESTMENT_CONSENT) {
    const { consent } = action;
    if (isBoolean(consent)) {
      return {
        ...state,
        consent
      };
    }
  }
  if (
    action.type === SET_EXTERNAL_INVESTMENT_CONSENT ||
    action.type === RECEIVED_SET_EXTERNAL_INVESTMENT_CONSENT
  ) {
    const { consent } = action;
    if (isBoolean(consent)) {
      return {
        ...state,
        consent
      };
    }
  }
  if (
    action.type === RECEIVED_EXTERNAL_INVESTMENT_STATUS ||
    action.type === UPDATE_EXTERNAL_INVESTMENT_STATUS
  ) {
    const { status } = action;
    return {
      ...state,
      status
    };
  }
  if (action.type === SHOW_CONSENT_MODAL) {
    const { showConsentModal: show } = action;
    return {
      ...state,
      showConsentModal: show
    };
  }
  if (action.type === SHOW_LINK_MODAL) {
    const { showLinkModal: show } = action;
    return {
      ...state,
      showLinkModal: show
    };
  }
  if (action.type === DELAY_LINK_ACCOUNT) {
    const { delayLinkAccount: delay } = action;
    return {
      ...state,
      delayLinkAccount: delay
    };
  }
  return state;
};
